var data = {
	"body": "<path fill=\"currentColor\" d=\"M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
